import React from 'react'

const Info = () => {
  return (
    <div className="about__info grid">
         <div className="about__box">
            <i className="bx bx-award about__icon"></i> {/* Fixed: Added className attribute */}

            <h3 className="about__title">Experience</h3>
            <span className="about__subtitle">3 years working</span>
         </div>
         
         <div className="about__box">
            <i className="bx bx-briefcase-alt about__icon"></i> {/* Fixed: Added className attribute */}

            <h3 className="about__title">Completed</h3>
            <span className="about__subtitle">20+ Projects</span>
         </div>

         <div className="about__box">
            <i className="bx bx-support about__icon"></i> {/* Fixed: Added className attribute */}

            <h3 className="about__title">Support</h3> {/* Fixed typo: "Surpport" -> "Support" */}
            <span className="about__subtitle">Geegstack Academy</span>
         </div>

    </div>
  )
}

export default Info;

